import React, { Suspense, lazy, useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
// Constants
import {
  ABOUT_ME_PAGE_URL,
  ADMIN_PAGE_URL,
  CONTACT_PAGE_URL,
  GALLERY_PAGE_URL,
  HOME_PAGE_URL,
  INDEX_PAGE_URL,
  MAINTENANCE_PAGE_URL,
  POLICIES_PAGE_URL,
  REVIEWS_PAGE_URL,
  SERVICES_PAGE_URL,
} from './utils/Constants';
// Components
import LoadingScreen from './components/utils/LoadingScreen';
// Utils
import { AuthenticateAdmin } from './utils/user/AuthenticateUser';
// Normal import for HomePage (no lazy loading)
import HomePage from './pages/home/HomePage';
import IndexPage from './pages/index/IndexPage';
import GalleryPage from './pages/gallery/GalleryPage';
import AboutPage from './pages/about/AboutPage';
import ServicesPage from './pages/services/ServicesPage';
import ContactPage from './pages/contact/ContactPage';
import ReviewsPage from './pages/reviews/ReviewsPage';
// Lazy-loaded Pages
const AdminPage = lazy(() => import('./pages/admin/AdminPage'));
const MaintenancePage = lazy(() =>
  import('./pages/maintenance/MaintenancePage')
);
const Error404 = lazy(() => import('./pages/error/Error404'));
const TermAndPoliciesPage = lazy(() =>
  import('./pages/policies/TermAndPoliciesPage')
);

function App() {
  return (
    <>
      {/* Suspense component wraps the lazy-loaded components */}
      <Suspense fallback={<LoadingScreen />}>
        <Routes>
          {/* Main page routes */}
          <Route path={INDEX_PAGE_URL} index element={<IndexPage />} />
          <Route path={HOME_PAGE_URL} element={<HomePage />} />
          <Route path={ABOUT_ME_PAGE_URL} element={<AboutPage />} />
          <Route path={GALLERY_PAGE_URL} element={<GalleryPage />} />
          <Route path={SERVICES_PAGE_URL} element={<ServicesPage />} />
          <Route path={REVIEWS_PAGE_URL} element={<ReviewsPage />} />

          {/* Eager loaded */}
          <Route path={CONTACT_PAGE_URL} element={<ContactPage />} />
          <Route path={POLICIES_PAGE_URL} element={<TermAndPoliciesPage />} />

          {/* Other */}
          <Route path={MAINTENANCE_PAGE_URL} element={<MaintenancePage />} />
          {/* Secured routes */}
          <Route
            path={ADMIN_PAGE_URL}
            element={
              <AuthenticateAdmin>
                <AdminPage />
              </AuthenticateAdmin>
            }
          />
          {/* Error routes */}
          <Route path='*' element={<Error404 />} />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
